export default __webpack_public_path__ + "static/media/store-signup-graphic@2x.d7ce3f1b.png";